import React, { useEffect, useState } from "react";

import portal, { AsistenciaCurso } from "../../../services/v2/portalAlumno.service";
import "./portal.css";

/* Mis Asistencias: historial por curso, de la clase más nueva a la más vieja. Presente / Ausente. */
const VISIBLES = 12

const Curso: React.FC<{ c: AsistenciaCurso }> = ({ c }) => {
	const [todas, setTodas] = useState<boolean>(false)
	const items = todas ? c.items : c.items.slice(0, VISIBLES)
	return (
		<div className="ptTarjeta ptCursoAsistencia">
			<div className="ptCursoCabeza">
				<div>
					<div className="ptTituloClase">{c.course}</div>
					{c.period ? <div className="ptPeriodo ptChico">{c.period}</div> : null}
				</div>
				<div className="ptAsistencia"><span className="ptAsistenciaNumero">{c.present}</span><span className="ptTenue">de {c.total}</span></div>
			</div>
			<div className="ptLista">
				{items.map((a, i) => (
					<div className="ptFila ptFilaChica" key={a.date + i}>
						<span className="ptFilaTitulo">{a.label}</span>
						<span className={"ptAsiste " + (a.present ? "ptPresente" : "ptOro")}>{a.present ? "Presente" : "Ausente"}</span>
					</div>
				))}
			</div>
			{c.items.length > VISIBLES ? <button type="button" className="ptEnlace" onClick={() => setTodas(!todas)}>{todas ? "Ver Menos" : "Ver Todas"}</button> : null}
		</div>
	)
}

const MisAsistencias: React.FC = () => {
	const [cursos, setCursos] = useState<AsistenciaCurso[] | null>(null)
	const [error, setError] = useState<boolean>(false)
	useEffect(() => {
		let vivo = true
		portal.attendances().then((r) => { if (vivo) setCursos(r.data.courses) }).catch(() => { if (vivo) setError(true) })
		return () => { vivo = false }
	}, [])
	if (error) return <div className="pt"><div className="ptVacio">No Pudimos Cargar Tus Asistencias</div></div>
	if (cursos === null) return <div className="pt"><div className="ptPagina ptUna"><div className="ptVacio">Cargando…</div></div></div>
	return (
		<div className="pt">
			<div className="ptPagina ptUna">
				<div className="ptColumna">
					<h1 className="ptH1">Mis Asistencias</h1>
					{cursos.length === 0 ? <div className="ptVacio">Aún No Tienes Asistencias</div> : cursos.map((c) => <Curso key={c.enrollmentId} c={c} />)}
				</div>
			</div>
		</div>
	)
}

export default MisAsistencias
